import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { ClienteXCiudad } from '../login/cliente_login';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos, Preguntas, Contacto, PreguntasSAES } from '../../components/common/utils/entities/util_entity';
import { Header } from 'primeng/primeng';

declare var jQuery: any;

@Injectable()
export class EncuestaSaesComponentService {
    private userEmpresa: ClienteXCiudad;
    private url = "utils";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    
    validacionEncuestaSaes(idsinestro: number): Observable<string>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/validacionEncuestaSaes/"+ idsinestro, options).map(this.extractData)
            .catch(this.handleError);
      }
      ConsultarPreguntas(idsinestro: number): Observable<PreguntasSAES[]>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/ConsultarPreguntasSaes/"+ idsinestro, options).map(this.extractData)
            .catch(this.handleError);
      }
    GuardarPreguntas(datos: PreguntasSAES[]): Observable<boolean> {
        let body = JSON.stringify(datos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GuardarRespuestasSaes", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/EncuetasSAES/EncuestaSaes.service.ts